/** Zustand der Benachrichtigungen (F-30): gelesen, erledigt, verschoben. */
import { db } from '@/db/schema';
import { setMeta } from '@/db/repositories/meta';
import { addDays } from '@/lib/datetime';
import type { MeldungsZustand } from '@/domain/benachrichtigungen/zustand';
import type { Einstellungen } from '@/domain/benachrichtigungen/einstellungen';
import type { LocalDate } from '@/domain/types';

export const META_BENACHRICHTIGUNGEN = 'benachrichtigungen';

export async function meldungAendern(id: string, datum: LocalDate, patch: Partial<Omit<MeldungsZustand, 'id' | 'datum'>>): Promise<void> {
  await db.transaction('rw', db.meldungen, async () => {
    const alt = await db.meldungen.get(id);
    await db.meldungen.put({ ...alt, ...patch, id, datum });
  });
}

export async function alleGelesen(liste: { id: string; datum: LocalDate }[]): Promise<void> {
  await db.transaction('rw', db.meldungen, async () => {
    for (const { id, datum } of liste) {
      const alt = await db.meldungen.get(id);
      await db.meldungen.put({ ...alt, id, datum, gelesen: 1 });
    }
  });
}

/** Alte Zustaende wegraeumen - Meldungen gelten nur fuer ihren Tag. */
export async function meldungenAufraeumen(heute: LocalDate): Promise<void> {
  await db.meldungen.where('datum').below(addDays(heute, -14)).delete();
}

export async function einstellungenSpeichern(e: Einstellungen): Promise<void> {
  await setMeta(META_BENACHRICHTIGUNGEN, e);
}
